import React, { useEffect, useState } from 'react';
import styles from './forms.module.scss';
import { KoButton, KoCheckBox, KoDateFormatter,  KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
import { Link, useParams } from 'react-router-dom';
import { workspaceAPI } from '../workspace.service';

export default function Forms() {
  const { workspaceId } = useParams();
  const [forms, setForms] = useState([]);

  useEffect(() => {
    workspaceAPI.getForms(workspaceId).then((res) => {
      setForms(res.forms || []);
    });
  }, [workspaceId]);

  const handleStatusChange = (index, checked) => {
    const updated = [...forms];
    updated[index].status = checked ? 1 : 0;
    setForms(updated);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <KoTitle text="Forms" level={3} />
        <KoButton color="primary" variant="solid" label="Create Form" onClick={() =>
          window.open(`/open/${workspaceId}/form/create`, '_blank')
        } />
      </div>

      <div className={styles.formcontent}>
        {forms.map((item, index) => (
          <div key={item.id} className={styles.formCard}>
            <Link to={`/open/${workspaceId}/form/${item.formId}`} target="_blank">
              <div className={styles.header}>
                <div className={styles.circle}>
                  <KoIcon name="FileOutlined" height={18} width={18} />
                </div>
                <KoTitle text={item.name} level={5} />
              </div>
              <div className={styles.content}>
                <KoIcon name="FormsLineOutlined" height={80} width={80} />
              </div>
            </Link>

            <div className={styles.footer}>
              <KoCheckBox
                checked={item.status === 1}
                onChange={(e) => handleStatusChange(index, e.target.checked)}
                label="Default"
              />

              <div className={styles.date}>
                <KoText text="Updated: " className={styles.email} />
                <KoDateFormatter
                  format="DD-MM-YYYY"
                  className={styles.email}
                  data={
                    item.updatedAt && item.updatedAt !== '0001-01-01T00:00:00Z'
                      ? item.updatedAt
                      : item.createdAt
                  }
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
